export const shortPresentationDimension = [
  'C_CURRENCY.CODE',
  'S_ACC.INT_RATE',
  'S_ACC.OBL_END_DATE',
  'S_QUOTE.PRICE_CLOSE',
  'S_MARKET.YIELD',
  'S_MARKET.QT_MIN',
  'GES_RAT_VAL_SP.SHORTCUT',
];
